import { Link } from 'react-router-dom';
import ScrollReveal from '@/components/common/ScrollReveal';
import GradientIcon from '@/components/common/GradientIcon';
import { resources } from '@/mocks/landing';
import SectionTitle from './SectionTitle';

export default function Resources() {
  return (
    <section className="w-full bg-white pb-16 md:pb-24">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <SectionTitle title={<>Learning resources to master<br className="hidden sm:block" /> loyalty and the API</>} />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {resources.map((r, i) => (
            <ScrollReveal key={r.title} animation="fade-up" delay={i * 70}>
              <Link
                to="/docs"
                className="group block rounded-2xl bg-white border border-[#eff0f1] overflow-hidden hover:shadow-[0_16px_40px_-24px_rgba(47,81,214,0.5)] hover:-translate-y-1 transition-all"
              >
                <div className={`relative h-28 bg-gradient-to-br ${r.art} flex items-center justify-center`}>
                  <span className="absolute top-2.5 left-2.5 rounded-md bg-white/85 text-[10px] font-semibold text-[#646a73] px-1.5 py-0.5">{r.tag}</span>
                  <span className="w-14 h-14 rounded-2xl bg-white shadow-sm flex items-center justify-center group-hover:scale-105 transition-transform">
                    <GradientIcon icon={r.icon} tone={r.tone} size="text-3xl" />
                  </span>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-bold text-[#1f2329] leading-snug min-h-[40px]">{r.title}</h3>
                  <div className="mt-3 flex items-center justify-between text-[11px] text-[#8f959e]">
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-book-open-line" /> {r.meta}
                    </span>
                    <span className="text-[#2f51d6] font-semibold">Start →</span>
                  </div>
                </div>
              </Link>
            </ScrollReveal>
          ))}
        </div>

        <div className="mt-8 flex justify-center">
          <Link
            to="/docs"
            className="inline-flex items-center h-9 px-5 rounded-full border border-[#dee0e3] text-xs font-semibold text-[#1f2329] hover:border-[#2f51d6] hover:text-[#2f51d6] transition-colors"
          >
            Browse all resources
          </Link>
        </div>
      </div>
    </section>
  );
}
